<template>
  <div class="lg:w-3/5 w-full">
    <h2 class="text-3xl font-bold">Who am I?</h2>
    <p class="py-3">I'm Luka Bulatovic, a 25 year old full-stack developer from Belgrade, Serbia.</p>
    <p class="py-3">Portfolio and blog soon...</p>
    <div class="flex flex-wrap justify-between">
      <div class="md:w-1/2 w-full">
        <h2 class="text-3xl font-bold">Contact Me</h2>
        <p class="py-3">
          <!-- <a href="mailto:luka.bulatovic.w@gmail.com" class="font-semibold text-teal-500 text-xl">luka.bulatovic.w@gmail.com</a> -->
          <a href="mailto:luka.bulatovic.w@gmail.com" style="font-weight:600;font-size: 1.25rem; color: #38b2ac;">luka.bulatovic.w@gmail.com</a>
        </p>
      </div>
      <div class="md:w-1/2 w-full">
        <h2 class="text-3xl font-bold">Follow Me</h2>
        <p class="py-3 flex">
          <a href="https://github.com/b3ndoi"  target="_blank" rel="noopener noreferrer"  class="font-semibold text-teal-500 text-xl px-3">
            <svg viewBox="0 0 128 128" class="scale h-8 w-8">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M64 5.103c-33.347 0-60.388 27.035-60.388 60.388 0 26.682 17.303 49.317 41.297 57.303 3.017.56 4.125-1.31 4.125-2.905 0-1.44-.056-6.197-.082-11.243-16.8 3.653-20.345-7.125-20.345-7.125-2.747-6.98-6.705-8.836-6.705-8.836-5.48-3.748.413-3.67.413-3.67 6.063.425 9.257 6.223 9.257 6.223 5.386 9.23 14.127 6.562 17.573 5.02.542-3.903 2.107-6.568 3.834-8.076-13.413-1.525-27.514-6.704-27.514-29.843 0-6.593 2.36-11.98 6.223-16.21-.628-1.52-2.695-7.662.584-15.98 0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033 11.526-7.813 16.59-6.19 16.59-6.19 3.287 8.317 1.22 14.46.593 15.98 3.872 4.23 6.215 9.617 6.215 16.21 0 23.194-14.127 28.3-27.574 29.796 2.167 1.874 4.097 5.55 4.097 11.183 0 8.08-.07 14.583-.07 16.572 0 1.607 1.088 3.49 4.148 2.897 23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z"></path><path d="M26.484 91.806c-.133.3-.605.39-1.035.185-.44-.196-.685-.605-.543-.906.13-.31.603-.395 1.04-.188.44.197.69.61.537.91zm-.743-.55M28.93 94.535c-.287.267-.85.143-1.232-.28-.396-.42-.47-.983-.177-1.254.298-.266.844-.14 1.24.28.394.426.472.984.17 1.255zm-.575-.618M31.312 98.012c-.37.258-.976.017-1.35-.52-.37-.538-.37-1.183.01-1.44.373-.258.97-.025 1.35.507.368.545.368 1.19-.01 1.452zm0 0M34.573 101.373c-.33.365-1.036.267-1.552-.23-.527-.487-.674-1.18-.343-1.544.336-.366 1.045-.264 1.564.23.527.486.686 1.18.333 1.543zm0 0M39.073 103.324c-.147.473-.825.688-1.51.486-.683-.207-1.13-.76-.99-1.238.14-.477.823-.7 1.512-.485.683.206 1.13.756.988 1.237zm0 0M44.016 103.685c.017.498-.563.91-1.28.92-.723.017-1.308-.387-1.315-.877 0-.503.568-.91 1.29-.924.717-.013 1.306.387 1.306.88zm0 0M48.614 102.903c.086.485-.413.984-1.126 1.117-.7.13-1.35-.172-1.44-.653-.086-.498.422-.997 1.122-1.126.714-.123 1.354.17 1.444.663zm0 0"></path>
            </svg>
          </a>
          <a href="https://www.linkedin.com/in/luka-bulatovic-728746137/"  target="_blank" rel="noopener noreferrer"  class="font-semibold text-teal-500 text-xl px-3">
            <svg viewBox="0 0 512 512" class="scale h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M512 64c0-35.323-28.677-64-64-64H64C28.677 0 0 28.677 0 64v384c0 35.323 28.677 64 64 64h384c35.323 0 64-28.677 64-64V64z" fill="#2867b2"/><g fill="#fff"><path d="M61.053 178.667h85.76v257.962h-85.76z"/><path d="M104.512 54.28C75.171 54.28 56 73.57 56 98.853c0 24.752 18.588 44.574 47.377 44.574h.554c29.903 0 48.516-19.822 48.516-44.574-.555-25.283-18.611-44.573-47.935-44.573zM357.278 172.601c-45.49 0-65.866 25.017-77.276 42.589v-36.523h-85.738c1.137 24.197 0 257.961 0 257.961h85.737V292.564c0-7.711.554-15.42 2.827-20.931 6.188-15.4 20.305-31.352 43.993-31.352 31.012 0 43.436 23.664 43.436 58.327v138.02h85.741v-147.93c0-79.237-42.305-116.097-98.72-116.097z" fill-rule="nonzero"/></g></svg>
          </a>
        </p>
      </div>
    </div>
    
    <!-- <p class="py-3">I'm Luka Bulatovic, a full-stack web developer from Serbia.</p> -->
    <!-- <p class="py-3">I'm Luka Bulatovic, a full-stack web developer from Serbia.</p> -->
  </div>
</template>

<script>
// import moment from 'moment';
export default {
  name: 'HelloWorld',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// h3 {
//   margin: 40px 0 0;
// }
// ul {
//   list-style-type: none;
//   padding: 0;
// }
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
// a {
//   color: #42b983;
// }
</style>
